import { getColorDataOfCountries } from "./map-get-country-data";
import { handleRegionClick } from "./map-handle-region-click";
import { createRegionOverHandler } from "./map-handle-region-over";
import { createRegionTipHandler } from "./map-handle-region-tip";
import { initializeVectorMap } from "./map-jvectormap-include";
import { initializeWorldMapBackButtonVisibilityHandling } from "./map-back-button";

import "jvectormap-next/jquery-jvectormap.css";
import "./map.scss";

const initializeMap = async (interactivityRootMapElement: HTMLElement) => {
  const countryColorData = getColorDataOfCountries(interactivityRootMapElement);

  const vectorMapOptions = {
    map: "world_mill",
    backgroundColor: "transparent",
    series: {
      regions: [
        {
          attribute: "fill",
          values: countryColorData,
          normalizeFunction: "polynomial",
        },
      ],
    },
    regionStyle: {
      initial: {
        fill: "#464646",
        "fill-opacity": 1,
        stroke: "none",
        "stroke-width": 0,
        "stroke-opacity": 1,
      },
      hover: {
        "fill-opacity": 1,
      },
    },
    hoverColor: false,
    onRegionClick: handleRegionClick,
    onRegionOver: createRegionOverHandler(countryColorData),
    onRegionTipShow: createRegionTipHandler(countryColorData),
  };

  initializeVectorMap(interactivityRootMapElement, vectorMapOptions);
  initializeWorldMapBackButtonVisibilityHandling(interactivityRootMapElement);
};

const waitForCss = (interactivityRootMapElement: HTMLElement) => {
  if (interactivityRootMapElement.clientHeight) {
    initializeMap(interactivityRootMapElement).catch((error: unknown) => {
      // eslint-disable-next-line no-console
      console.error(
        "Failed to initialize interactive world map element",
        error
      );
    });
  } else {
    window.setTimeout(() => {
      waitForCss(interactivityRootMapElement);
    }, 100);
  }
};

for (const interactivityRootMapElement of document.getElementsByClassName(
  "js-world-map"
)) {
  if (!(interactivityRootMapElement instanceof HTMLElement)) {
    continue;
  }

  waitForCss(interactivityRootMapElement);
}
